var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 2.8125V8.4375L28.125 7.5V3.75L26.25 2.8125Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 15L28.125 14.0625V10.3125L26.25 9.375V15Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 21.5625L28.125 20.625V16.875L26.25 15.9375V21.5625Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 25.3125H5.625V27.1875H22.5V25.3125Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 0C3.5625 0 1.875 1.6875 1.875 3.75V26.25C1.875 28.3125 3.5625 30 5.625 30H23.8125L25.3125 28.5V25.3125H23.4375V27.75L23.0625 28.125H5.625C4.59375 28.125 3.75 27.2812 3.75 26.25C3.75 25.2188 4.59375 24.375 5.625 24.375H23.8125L25.3125 22.875V1.5L23.8125 0H5.625ZM14.0625 7.03125C15.0938 7.03125 15.9375 7.875 15.9375 8.90625C15.9375 9.9375 15.0938 10.7812 14.0625 10.7812C13.0312 10.7812 12.1875 9.9375 12.1875 8.90625C12.1875 7.875 13.0312 7.03125 14.0625 7.03125ZM17.8125 17.3438H10.3125V13.5938L13.125 12.6562H15L17.8125 13.5938V17.3438Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactsIcon);
export default __webpack_public_path__ + "static/media/contacts-icon.f0c6c1a24e74d0851327656c84fec6ee.svg";
export { ForwardRef as ReactComponent };